import { render, staticRenderFns } from "./preferential.vue?vue&type=template&id=6b8686b8&scoped=true"
import script from "./preferential.vue?vue&type=script&lang=js"
export * from "./preferential.vue?vue&type=script&lang=js"
import style0 from "./preferential.vue?vue&type=style&index=0&id=6b8686b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8686b8",
  null
  
)

export default component.exports